import React, { useState } from "react";

import { Button, Popover, Stack, Typography } from "@mui/material";
import { useDealAssetClassSelect } from "store";

import { Content } from "./Content";

interface IAsset {
  isAdmin: boolean;
  disablePopup?: boolean;
}

export const Asset: React.FC<IAsset> = ({ isAdmin, disablePopup }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const dealAssetClass = useDealAssetClassSelect();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "deal-asset-popover" : undefined;

  if (!dealAssetClass && !isAdmin) return null;

  return (
    <>
      <Button
        sx={{
          color: dealAssetClass?.name ? "#173c4c" : "#5d7782",
          padding: "0 10px",
          minWidth: "auto",
          fontSize: "15px",
          backgroundColor: "#edf1f9",
          minHeight: "28px",
          maxHeight: "28px"
        }}
        onClick={(e) => !disablePopup && handleClick(e)}
        className="trigger"
      >
        <Stack
          direction="row"
          sx={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            maxWidth: "200px",
            fontSize: "12px",
            fontWeight: "400"
          }}
          gap="5px"
        >
          <Typography sx={{ color: "#496682" }}>Asset Class:</Typography>
          <Typography sx={{ color: "#071F35", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
            {dealAssetClass?.account_alias || "N/A"}
          </Typography>
        </Stack>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <Content assetClass={dealAssetClass} close={handleClose} viewOnly={!isAdmin} />
      </Popover>
    </>
  );
};
